import { useContext } from "react";

import { CurrentDetectorContextProps, detectorContext } from "context/detectorIdContext/detectorContext";

export function useDetectorContext() {
  const context = useContext(detectorContext) as CurrentDetectorContextProps;

  if (!context) {
    throw new Error("useIdContext must be used within a DetectorProvider");
  }

  return context as CurrentDetectorContextProps;
}
